export default __webpack_public_path__ + "resources/icons/d232-4496.png";